/* TYB product-page Judge.me runtime contrast guard.
   Judge.me can inject/re-style its product review app block after page load.
   Apply inline-important text colors only inside Broadcast's product Apps section. */
(() => {
  'use strict';

  const ROOT_SELECTOR = 'body.template-product .tyb-apps-section';
  const CANDIDATE_SELECTOR = 'h1,h2,h3,h4,h5,h6,p,div,span,strong,small,label,a,li';
  const TEXT = '#f3f1eb';
  const MUTED = '#aaa69e';
  const LINK = '#c3a27a';
  let scheduled = false;

  const hasDirectText = (el) => Array.from(el.childNodes).some(
    (node) => node.nodeType === Node.TEXT_NODE && (node.textContent || '').trim().length > 0
  );

  const isExcluded = (el) => {
    if (!(el instanceof HTMLElement)) return true;
    if (el.matches('button,input,textarea,select,option')) return true;
    if (el.closest('button')) return true;
    if (el.matches('.jdgm-write-rev-link,[class*="btn" i],[class*="button" i]')) return true;
    if (el.matches('.jdgm-star,[class*="star" i],[class*="icon" i]')) return true;
    if (el.closest('.jdgm-star,[class*="star" i],svg')) return true;
    return false;
  };

  const desiredColor = (el) => {
    const classes = String(el.className || '').toLowerCase();
    const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    const lower = text.toLowerCase();

    if (
      classes.includes('timestamp') ||
      classes.includes('review-date') ||
      classes.includes('review_date') ||
      /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(text)
    ) return MUTED;

    if (
      classes.includes('read-more') ||
      classes.includes('read_more') ||
      classes.includes('body-read-more') ||
      lower === 'more' ||
      lower === 'read more'
    ) return LINK;

    return TEXT;
  };

  const paint = (el) => {
    if (isExcluded(el) || !hasDirectText(el)) return;
    const color = desiredColor(el);
    el.style.setProperty('color', color, 'important');
    el.style.setProperty('-webkit-text-fill-color', color, 'important');
    if (window.getComputedStyle(el).opacity === '0') {
      el.style.setProperty('opacity', '1', 'important');
    }
  };

  const apply = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (!(root instanceof HTMLElement)) return;
      root.querySelectorAll(CANDIDATE_SELECTOR).forEach(paint);
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  };

  const start = () => {
    schedule();
    [100,300,700,1400,2500,4500,8000].forEach((delay) => window.setTimeout(schedule, delay));
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
